module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaS1zdGFyIiBmaWxsPSIjZmZlZTA2IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMSA5LjgzMiI+CiAgPHBhdGggZD0iTTQuMTI1IDMuNjU3TDAgMy43NTZsMy4yNzUgMi4zNTgtMS4xNzQgMy43MTggMy4zOTktMi4yIDMuNCAyLjItMS4xNzUtMy43MThMMTEgMy43NTZsLTQuMTI1LS4wOTlMNS41IDAgNC4xMjUgMy42NTd6Ii8+Cjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/svgs/star.svg
// module id = 809
// module chunks = 35783957827783